import { validates } from '../utils/ValidateFormObject'

const capitulo = {
  tipo: {
    required: true
  },
  document: {
    conditionalRequired(obj) {
      const errorMessage = 'É obrigatório o upload de um arquivo HTML.'
      if (!obj['conteudoHtml']) {
        return {
          required: true,
          errorMessage
        }
      } else {
        return {
          required: false,
          errorMessage
        }
      }
    }
  },
  titulo: {
    required: true
  },
  autores: {
    required: true
  },
  especialidades: {
    required: true
  },
  pesoDA: {
    required: true
  },
  idioma: {
    required: true
  },
  palavrasChave: {
    required: true
  },
  codigo: {
    required: true,
    func: validates.codigoCapitulo,
    errorMessage: 'Este código deve seguir o padrão 0000000000000_S00C000.'
  },
  codigoProtheus: {
    required: true,
    func: validates.isbn,
    errorMessage: 'Este campo deve conter um número de ISBN válido.'
  },
  tituloLivro: {
    required: true
  },
  autoresLivro: {
    required: true
  },
  copyrightLivro: {
    required: true,
    func: validates.copyright,
    errorMessage: 'Este campo deve conter 4 dígitos numéricos.'
  },
  isbn: {
    required: true,
    func: validates.isbn,
    errorMessage: 'Este campo deve conter um número de ISBN válido.'
  },
  edicaoLivro: {
    required: true
  },
  especialidadesLivro: {
    required: true
  },
  tituloSecao: {
    required: false
  },
  autoresSecao: {
    required: false
  },
  textoSecao: {
    required: false
  },
  livroReferencia: {
    required: false
  }
}

export default capitulo



// WEBPACK FOOTER //
// ./src/contentSchema/capitulo.js